// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--_PF22","icon":"_02712f2b3b--icon--GYbz7"};